import { observable, computed, action, makeObservable } from 'mobx';

class ServerStore {
    openedServer;
    isServerDialogOpened;
    updateHandler;

    isEnvironmentOpened;
    openedEnvironment;
    environmentUpdateHandler;

    constructor() {
        

        this.openedServer = { description: '' };
        this.isServerDialogOpened = false;
        this.updateHandler = () => { };

        this.openedEnvironment = {};
        this.isEnvironmentOpened = false;
        this.environmentUpdateHandler = () => { };

        makeObservable(this, {
            updateHandler: observable,
            openedServer: observable,
            isServerDialogOpened: observable,
            openServerDialog: action,
            closeServerDialog: action,
            setAutorunFunction: action,
            setOpenedServer: action,

            isEnvironmentOpened: observable,
            openedEnvironment: observable,
            openServerEnvironment: action,
            closeServerEnvironment: action,
            environmentUpdateHandler: observable,
            setEnvironmentUpdateFunction: action,
            setOpenedEnvironment: action,


        });
    }

    openServerDialog(server) {
        this.openedServer = server;
        this.isServerDialogOpened = true;
    }

    closeServerDialog() {
        this.openedServer = { description : ''};
        this.isServerDialogOpened = false;
    }

    setOpenedServer(server) {
        this.openedServer = server;
    }

    setAutorunFunction(updateHandler) {
        this.updateHandler = updateHandler;
    }

    openServerEnvironment(environment) {
        this.openedEnvironment = environment;
        this.isEnvironmentOpened = true;
    }

    closeServerEnvironment() {
        this.openedEnvironment = { };
        this.isEnvironmentOpened = false;
    }

    setEnvironmentUpdateFunction(updateHandler) {
        this.environmentUpdateHandler = updateHandler;
    }

    setOpenedEnvironment(value) {
        this.openedEnvironment = value;
    }

    setOpenedServer(server) {
        this.openedServer = server;
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}

const serverStore = new ServerStore();

export default serverStore;
export { ServerStore };